
import React  from 'react';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
import { FormattedMessage } from 'react-intl';
import StudentsTable from '../components/tables/students-table.js';
import Toggle from '../components/inputs/input.toggle.component.js';
import {Breadcrumb , Button} from "react-bootstrap"
import StudentEditForm from '../components/forms/student-edit-form.js';
import StudentsStore from '../store/student-store.js';
import StudentsService from '../services/student-services.js';
import Modal from 'react-bootstrap/lib/Modal';
import AuthneticationStore from "../store/authentication-store.js";

export default class ScoresComponent extends React.Component {

    constructor(props) {
        super();

        this.state = {
            allStudents: false,
            deleteComfirm:false,
            student: {}
        };
        this.onLanguageToggle = this.onLanguageToggle.bind(this);
    }

    onLanguageToggle(){
        this.setState({allStudents:!this.state.allStudents});
    }

    getBreadCrumb(){

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={ 'ui-783' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
        </Breadcrumb>
    }

    handleCancelEdit(){
        StudentsService.getAllViewableStudents();
        this.setState({editUser:false , student:{}});
    };

    handleEdit(fields){

        var user = StudentsStore.getStudentByID(fields[0].id);

        if(user === null) return;

        this.setState({editUser:true , student:user});
    }

    handleDelete(fields){

        var user = StudentsStore.getStudentByID(fields[0].id);
        if(user === null) return;
        this.setState({deleteComfirm:true , student:user});
    }

    deleteObject(){

        StudentsService.deleteStudent(this.state.student.uid).then(function(){
            this.handleComfirmExit();
         }.bind(this))
      
    }

    handleComfirmExit(){
        StudentsService.getAllViewableStudents();
        this.setState({deleteComfirm:false , student:{}});
    }

    render(){
        return (<Layout>
            {this.getBreadCrumb()}
            
            <Modal show={this.state.editUser} onHide={this.handleCancelEdit.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-10">
                        <StudentEditForm student={this.state.student} onCreated={this.handleCancelEdit.bind(this)} />
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={this.state.deleteComfirm} onHide={this.handleComfirmExit.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Header closeButton>
                    <FormattedMessage id={'ui-444'} defaultMessage={'Delete'} /> {this.state.student.name}
                </Modal.Header>
                <Modal.Body>
                    <FormattedMessage id={'ui-667'} defaultMessage={'Are You Sure'} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleComfirmExit.bind(this)}><FormattedMessage id={'ui-41'} defaultMessage={'Cancel'} /></Button>
                    <Button onClick={this.deleteObject.bind(this)} bsStyle="primary"><FormattedMessage id={'ui-444'} defaultMessage={'Delete'} /></Button>
                </Modal.Footer>
            </Modal>



            <Card>
                <CardHead>
                    <div className="row">
                        <h2 className="">
                            <FormattedMessage id={"ui-000"} defaultMessage={"Student Management"} />
                            <small>
                                <FormattedMessage id={ 'ui-2177' } defaultMessage={ 'Assigned Students' }/>
                            </small>
                        </h2>
                    </div>
                </CardHead>
                <CardBody noPadding>
                    <StudentsTable
                         handleEdit={AuthneticationStore.hasCreatePermissions() ? this.handleEdit.bind(this) : null }
                         handleDelete={AuthneticationStore.hasCreatePermissions() ? this.handleDelete.bind(this) : null }

                    />
                </CardBody>
            </Card>
        </Layout>);
    }
}




// WEBPACK FOOTER //
// ./src/screens/student-management.js